// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 3t7wZMgJPQyyMw4DqH4rwx
// Component: fFQdM2fMo5
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import "@plasmicapp/react-web/lib/plasmic.css";
import * as defaultcss from "../plasmic__default_style.module.css"; // plasmic-import: global/defaultcss
import * as projectcss from "./plasmic_valentino.module.css"; // plasmic-import: 3t7wZMgJPQyyMw4DqH4rwx/projectcss
import * as sty from "./PlasmicPreevent.module.css"; // plasmic-import: fFQdM2fMo5/css
import logo3XpngESkE6BC9Z from "./images/logo3Xpng.png"; // plasmic-import: eSkE6bC9Z/picture

export const PlasmicPreevent__VariantProps = new Array();

export const PlasmicPreevent__ArgProps = new Array();

function PlasmicPreevent__RenderFunc(props) {
  const { variants, args, overrides, forNode, dataFetches } = props;
  return (
    <React.Fragment>
      <div className={defaultcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            defaultcss.all,
            projectcss.root_reset,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"formBody"}
            data-plasmic-override={overrides.formBody}
            className={classNames(defaultcss.all, sty.formBody)}
          >
            <img
              data-plasmic-name={"logo"}
              data-plasmic-override={overrides.logo}
              alt={""}
              className={classNames(defaultcss.img, sty.logo)}
              role={"img"}
              src={logo3XpngESkE6BC9Z}
            />
          </div>

          <div className={classNames(defaultcss.all, sty.box__tzK)}>
            <div
              className={classNames(
                defaultcss.all,
                defaultcss.__wab_text,
                sty.box__gyu1U
              )}
            >
              {"Return on June 22nd @ 3pm EST to join the event"}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "formBody", "logo"],
  formBody: ["formBody", "logo"],
  logo: ["logo"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicPreevent__ArgProps,
      internalVariantPropNames: PlasmicPreevent__VariantProps
    });

    const { dataFetches } = props;
    return PlasmicPreevent__RenderFunc({
      variants,
      args,
      overrides,
      dataFetches,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPreevent";
  } else {
    func.displayName = `PlasmicPreevent.${nodeName}`;
  }
  return func;
}

export const PlasmicPreevent = Object.assign(
  // Top-level PlasmicPreevent renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    formBody: makeNodeComponent("formBody"),
    logo: makeNodeComponent("logo"),
    // Metadata about props expected for PlasmicPreevent
    internalVariantProps: PlasmicPreevent__VariantProps,
    internalArgProps: PlasmicPreevent__ArgProps
  }
);

export default PlasmicPreevent;
/* prettier-ignore-end */
